export const LOG_TAG = 'GO-CC';
let isDisabled = false;

/**
 * Creates a logger with a given prefix.
 *
 * @export
 * @param {string} prefix Prefix of the logger.
 * @returns {Object} Logger prefixed.
 */
export function create(prefix) {
  return {
    debug: (...msgs) => print('debug', prefix, msgs),
    info: (...msgs) => print('info', prefix, msgs),
    warn: (...msgs) => print('warn', prefix, msgs),
    error: (...msgs) => print('error', prefix, msgs)
  };
}

/**
 * Diables logs.
 *
 * @export
 */
export function disable() {
  isDisabled = true;
}

/**
 * Prints a message in console.
 *
 * @param {string} type Type of the message.
 * @param {string} prefix Prefix of the message.
 * @param {*} msgs Messages to be concatenated.
 */
function print(type, prefix, msgs) {
  // Only debug mode is working on CC.
  // Those 3 types had their functions changed and don't print anything.
  if (!isDisabled) {
    const castDebugLogger = cast.debug.CastDebugLogger.getInstance();
    const color = `color:${type === 'error' || type === 'warn' ? 'color: white;' : ''}`;
    const bgColor = `background:${type === 'error' ? 'red' : type === 'warn' ? 'orange' : ''}`;

    console.debug(
      `%c[${LOG_TAG}] ${prefix}: ${msgs
        .map((msg) => (typeof msg === 'string' ? msg : JSON.stringify(msg)))
        .join(' ')}`,
      `${color};${bgColor}`
    );
    castDebugLogger[type]?.(
      LOG_TAG,
      `${prefix}: ${msgs
        .map((msg) => (typeof msg === 'string' ? msg : JSON.stringify(msg)))
        .join(' ')}`
    );
  }
}
